<div class="modal-header">

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="modal-title">
    {{ config?.action == WorkflowConfigurationSaveAction.Import ? 'Import' : 'Copy' }}
    {{ sourceWorkflowName }}
  </div>
</div>

<mat-dialog-content class="import-workflow-modal">
  <!-- Loader -->
  <ng-container *ngIf="loading">
    <app-loader></app-loader>
    <div class="text-center mt-2">
      Please wait while the workflow is analyzed...
    </div>
  </ng-container>

  <!-- Accordion -->
  <mat-accordion *ngIf="!loading" multi="true">
    <mat-expansion-panel
      *ngFor="let section of sections; let i = index"
      class="custom-panel"
      [hidden]="!section.enabled"
      [expanded]="expandedIndex === i"
      (opened)="expandedIndex = i"
      [hideToggle]="true"
    >
      <!-- Header -->
       <mat-expansion-panel-header>
        <!-- LEFT TEXT -->
        <mat-panel-title class="panel-title">
          {{ section.label }}
        </mat-panel-title>
        <!-- RIGHT ICON -->
        <mat-panel-description class="panel-icon">
          <span *ngIf="section.completed" class="success-icon">✔</span>
          <span *ngIf="!section.completed && section.enabled" class="warning-icon">⚠</span>
        </mat-panel-description>

      </mat-expansion-panel-header>

      <!-- Body -->
      <div class="section-body">
        <ng-container [ngSwitch]="section.key">
          <!-- Section 0: Workflow Name and Description -->
          <div *ngSwitchCase="'workflow-settings'">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form [formGroup]="workflowSettingsForm">

                    <!-- NAME -->
                    <div class="form-group">
                      <wm-common-textfield
                        [(ngModel)]="config.workflowUpdates.name"
                        formControlName="workflowName"
                        [data]="{
                          label: 'Workflow Name',
                          placeholder: 'Enter workflow name'
                        }">
                      </wm-common-textfield>

                      <wm-control-message
                        [control]="workflowSettingsForm.controls['workflowName']">
                      </wm-control-message>
                    </div>

                    <!-- DESCRIPTION -->
                    <div class="form-group">
                      <wm-common-textfield
                      [(ngModel)]="config.workflowUpdates.description"
                      formControlName="description"
                      [data]="{
                        label: 'Description',
                        placeholder: 'Enter description'
                      }"
                      (valueChange)="onDescChange($event)">
                      </wm-common-textfield>

                      <wm-control-message
                        [control]="workflowSettingsForm.controls['description']">
                      </wm-control-message>
                    </div>
                  </form>
                </div>
              </div>

              <!-- ACTION BUTTONS -->
              <div class="import-workflow-modal-actions">
                <div class="import-workflow-modal-gray-btn">
                  <wm-common-button
                    (click)="isSaving = true; saveForLater()"
                    [disabled]="isSaving"
                    [data]="{
                      text: 'Save for Later',
                      type: 'secondary'
                    }">
                  </wm-common-button>
                </div>

                <div class="import-workflow-modal-blue-btn">
                  <wm-common-button
                    (click)="
                      isSaving = true;
                      config.workflowUpdates.completed = true;
                      nextSection()
                    "
                    [disabled]="isSaving || workflowSettingsForm.invalid"
                    [data]="{
                      text: 'Next',
                      type: 'primary'
                    }">
                  </wm-common-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 1: Map Roles -->
          <div *ngSwitchCase="'roles'">
            <form class="form-group" [formGroup]="roleMappingsForm">
              <div *ngFor="let roleMapping of config?.roleMappings?.mappings || []">

                <wm-common-text
                  [data]="{ text: roleMapping.sourceRoleName +' changes to:' }">
                </wm-common-text>
                <span class="text-danger">*</span>

                <!-- DROPDOWN -->
                 <!-- Start Code added by Sanchit on 06/18/2026 -->
                 <wm-common-dropdown
                  *ngIf="roleMappingsForm.get(roleMapping.sourceRoleId)"
                  [formControlName]="roleMapping.sourceRoleId"
                  [data]="{
                    placeholder: '+ADD ROLE TO DESTINATION',
                    options: roleOptions
                  }"
                  (change)="onRoleChange($event, roleMapping)">
                </wm-common-dropdown>
                <!-- End Code added by Sanchit on 06/18/2026 -->
                <!-- <wm-common-dropdown
                  *ngIf="roleMappingsForm.get(roleMapping.sourceRoleId)"
                  [formControlName]="roleMapping.sourceRoleId"
                  [data]="{
                    placeholder: '+ADD ROLE TO DESTINATION',
                    options: targetResources?.responsibleRoles || [],
                    bindLabel: 'name',
                    bindValue: 'id'
                  }">
                </wm-common-dropdown> -->
                <!-- <mat-form-field>
                  <mat-select [formControl]="roleMappingsForm.controls[roleMapping.sourceRoleId]">
                    <mat-option *ngFor="let role of targetResources?.responsibleRoles" [value]="role.id">
                      {{ role.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->

                <!-- VALIDATION -->
                <wm-control-message
                  [control]="roleMappingsForm.controls[roleMapping.sourceRoleId]">
                </wm-control-message>

              </div>
            </form>

            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.roleMappings.completed = true;
                    nextSection()
                  "
                  [disabled]="isSaving || roleMappingsForm.invalid"
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- Section 2: Map Custom Lists and Items -->
          <div *ngSwitchCase="'custom-lists'">
            <form class="form-group" *ngIf="customListMappingsForm" [formGroup]="customListMappingsForm">
              <div *ngFor="let cl of config?.customListMappings?.mappings" class="card-box">

                <div class="row-container">

                  <!-- LEFT -->
                  <div class="left">
                    <wm-common-text [data]="{ text: cl.sourceListName }"></wm-common-text>
                  </div>

                  <!-- RIGHT -->
                  <div class="right">

                    <!-- LABEL -->
                    <div class="label-row">
                      <wm-common-text [data]="{ text: 'Changes to Target List:' }"></wm-common-text>
                      <span class="text-danger">*</span>
                    </div>

                    <!-- DROPDOWN WRAPPER -->
                    <div class="dropdown-wrapper">

                      <wm-common-dropdown
                        *ngIf="customListMappingsForm.get(cl.sourceListId)"
                        [formControlName]="cl.sourceListId"
                        [data]="{
                          placeholder: '+ Add Custom List to Destination',
                          options: customListOptions,
                          style: {
                            width: '100%'
                          }
                        }">
                      </wm-common-dropdown>

                    </div>

                  </div>

                </div>

              </div>

            </form>

            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.roleMappings.completed = true;
                    nextSection()
                  "
                  [disabled]="isSaving || roleMappingsForm.invalid"
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>

          </div>

           <!-- Section 3: Map Fee Recipients -->
          <div *ngSwitchCase="'fee-recipients'">
            <form [formGroup]="feeRecipientMappingsForm">
              <!-- WARNING -->
              <div *ngIf="config.feeUpdates?.completed" class="warning-box">
                "Review & Edit Workflow Fees" has already been completed, but changes made
                here will require re-review.
              </div>

              <div *ngFor="let mapping of config?.feeRecipientMappings?.mappings" class="card-box">
                <div class="row-container">
                  <div class="map-fee-left">
                    <wm-common-text [data]="{ text: mapping.sourceValue }"></wm-common-text>
                  </div>

                  <div class="map-fee-middle">
                    <div class="map-fee-toggle-row">
                      <input
                        type="checkbox"
                        class="native-toggle"
                        [formControlName]="mapping.sourceId + '_ignored'"
                      />

                      <wm-common-text
                        [data]="{ text: 'Don`t use this Fee Recipient' }">
                      </wm-common-text>
                    </div>
                  </div>

                  <div class="map-fee-right" *ngIf="!feeRecipientMappingsForm.get(mapping.sourceId + '_ignored')?.value">
                    <div class="label-row">
                      <wm-common-text [data]="{ text: mapping.sourceValue + ' changes to:' }"></wm-common-text>
                      <span class="text-danger">*</span>
                    </div>

                    <div class="dropdown-wrapper">
                      <wm-common-dropdown
                        [formControlName]="mapping.sourceId"
                        [data]="{
                          placeholder: '+ Add Fee Recipient to Destination',
                          options: feeRecipientOptions,
                          style: { width: '100%' }
                        }">
                      </wm-common-dropdown>
                    </div>

                    <wm-control-message
                      [control]="feeRecipientMappingsForm.controls[mapping.sourceId]">
                    </wm-control-message>

                  </div>
                </div>
              </div>
            </form>

            <!-- ACTIONS -->
            <div class="import-workflow-modal-actions">

              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{ text: 'Save for Later', type: 'secondary' }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.feeRecipientMappings.completed = true;
                    updateFeeRecipientUsage();
                    nextSection()
                  "
                  [disabled]="isSaving"
                  [data]="{ text: 'Next', type: 'primary' }">
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- Section 4: Review/Edit Fees -->
          <div *ngSwitchCase="'fees'">
            <form [formGroup]="feeUpdatesForm">
              <div
                *ngFor="let feeDE of config?.feeUpdates?.feeDataEntities"
                class="card-box"
              >
                <!-- TITLE -->
                <div class="fee-title">
                  <wm-common-text [data]="{ text: feeDE.label }"></wm-common-text>
                </div>

                <!-- EDITOR -->
                <div class="fee-editor">

                  <wm-fee-data-entity-editor

                    [form]="feeUpdatesForm?.controls?.[feeDE.templateCode]"
                    [dataEntity]="feeDE"
                    [activity]="feeDE.parentActivitySurrogate"
                    [workflowVersionId]="config.sourceWorkflowVersionId"
                    [targetClientId]="targetJurisdictionId"
                    [globalTarget]="!targetJurisdictionId"
                    [showManageFeeRecipientsLink]="false"
                  >
                  </wm-fee-data-entity-editor>
                </div>
              </div>
            </form>

            <!-- ACTION BUTTONS -->
            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.feeUpdates.completed = true;
                    nextSection()
                  "
                  [disabled]="isSaving || feeUpdatesForm?.invalid"
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- Section 5: Review/Edit Email Footers -->
          <div *ngSwitchCase="'email-footers'">
            <!-- <form [formGroup]="emailFooterMappingsForm"> -->
            <form
              *ngIf="emailFooterMappingsForm && config?.emailFooterMappings?.mappings?.length"
              [formGroup]="emailFooterMappingsForm"
            >
              <div *ngIf="config.emailUpdates?.completed" class="warning-box">
                "Review & Edit Workflow Emails" has already been completed. Changes here will require re-review.
              </div>

              <div
                *ngFor="let mapping of config?.emailFooterMappings?.mappings"
                class="card-box"
                [formGroupName]="mapping.sourceEmailFooter.id"
              >

                <div class="email-footer-row-container">
                  <div class="email-footer-left">
                    <wm-common-text
                      [data]="{ text: mapping.sourceEmailFooter.label }">
                    </wm-common-text>
                  </div>

                  <div class="email-footer-middle">
                    <div class="email-footer-toggle-row">
                      <input
                        type="checkbox"
                        class="native-toggle"
                        formControlName="isIgnored"
                      />

                      <wm-common-text
                        [data]="{ text: 'Don`t use this Email Footer' }">
                      </wm-common-text>

                    </div>
                  </div>

                  <div
                    class="email-footer-right"
                    *ngIf="!emailFooterMappingsForm
                      ?.get(mapping.sourceEmailFooter.id + '.isIgnored')?.value"
                  >

                    <div class="label-row">
                      <wm-common-text
                        [data]="{ text: mapping.sourceEmailFooter.label + ' changes to:' }">
                      </wm-common-text>
                      <span class="text-danger">*</span>
                    </div>

                    <div class="dropdown-wrapper">
                      <wm-common-dropdown
                        formControlName="targetId"
                        [data]="{
                          placeholder: '+ Add Email Footer to Destination',
                          options: emailFooterOptions,
                          style: { width: '100%' }
                        }">
                      </wm-common-dropdown>
                    </div>

                    <wm-control-message
                      [control]="emailFooterMappingsForm
                        ?.get(mapping.sourceEmailFooter.id + '.targetId')">
                    </wm-control-message>

                  </div>
                </div>

                <div
                  class="editor-section"
                  *ngIf="
                    !emailFooterMappingsForm
                      ?.get(mapping.sourceEmailFooter.id + '.targetId')?.value &&
                    !emailFooterMappingsForm
                      ?.get(mapping.sourceEmailFooter.id + '.isIgnored')?.value
                  "
                >

                  <div class="editor-label">
                    <wm-common-text [data]="{ text: 'Edit Footer Content' }">
                    </wm-common-text>
                  </div>

                  <wm-email-footer-content-editor
                    [emailFooterId]="mapping.sourceEmailFooter.id"
                    [emailFooterHtmlContent]="mapping.targetEmailFooterContent || ''"
                    [form]="emailFooterMappingsForm?.controls?.[mapping.sourceEmailFooter.id]"
                    (contentEdited)="
                      updateTargetEmailFooterContent(
                        $event,
                        mapping.sourceEmailFooter.id
                      )
                    "
                  >
                  </wm-email-footer-content-editor>

                </div>
              </div>
            </form>

            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{ text: 'Save for Later', type: 'secondary' }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.emailFooterMappings.completed = true;
                    updateEmailFooterUsage();
                    nextSection()
                  "
                  [disabled]="isSaving || emailFooterMappingsForm?.invalid"
                  [data]="{ text: 'Next', type: 'primary' }">
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- Section 6: Review/Edit Emails -->
          <!-- Start Code Added by Sanchit on 04/16/2026 -->
          <div *ngSwitchCase="'emails'">
            <form [formGroup]="emailUpdatesForm">

              <div *ngIf="config.emailUpdates?.completed" class="warning-box">
                "Review & Edit Workflow Emails" has already been completed. Changes here will require re-review.
              </div>

              <mat-accordion multi="false">
                <mat-expansion-panel
                  *ngFor="let emailActivity of config?.emailUpdates?.emailActivities; let i = index"
                  [expanded]="expandedEmailIndex === i"
                  (opened)="expandedEmailIndex = i"
                  class="custom-panel"
                  [hideToggle]="true"
                >

                  <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title">
                      {{ emailActivity.model?.screenName }}
                    </mat-panel-title>
                    <mat-panel-description class="panel-status">
                      <span *ngIf="emailActivity.completed" class="success-icon">✔</span>
                      <span *ngIf="!emailActivity.completed" class="pending-icon">⚠</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <div class="section-body">
                    <div class="section-header">
                      <div class="section-title">
                        <wm-common-text
                          [data]="{ text: emailActivity.model?.screenName }">
                        </wm-common-text>
                      </div>

                      <div class="section-action">
                        <div class="import-workflow-modal-blue-btn">
                          <wm-common-button
                            (click)="openEmailDesign(emailActivity, $event)"
                            [data]="{
                              text: 'View in Design',
                              type: 'secondary'
                            }">
                          </wm-common-button>
                        </div>
                      </div>
                    </div>

                    <div class="section-content">
                      <wm-email-activity-editor
                        *ngIf="expandedEmailIndex === i"
                        #emailActivityEditors
                        [workflowVersionId]="config.sourceWorkflowVersionId"
                        [form]="emailUpdatesForm?.controls?.[emailActivity.id]"
                        [activity]="emailActivity"
                        [viewInModal]="false"
                        [loadFull]="true"
                        [showEmailFooterManagementLink]="false"
                        [hideHeader]="true"
                        [targetClientId]="targetJurisdictionId"
                        [globalTarget]="!targetJurisdictionId"
                      >
                      </wm-email-activity-editor>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </form>

            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.emailUpdates.completed = true;
                    nextSection()
                  "
                  [disabled]="
                    isSaving ||
                    (!isGlobalAdmin && emailUpdatesForm?.invalid)
                  "
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>
          </div>
          <!-- Start Code Added by Sanchit on 04/16/2026 -->

          <!-- Start Code Added by Sanchit on 04/15/2026 -->
          <!-- Section 7: Review/Edit Print Tempaltes -->
          <div *ngSwitchCase="'print-templates'">
            <form
              *ngIf="printTemplateFormReady && printTemplateUpdatesForm"
              [formGroup]="printTemplateUpdatesForm"
            >
              <div
                *ngFor="let activity of config?.printTemplateUpdates?.printTemplateActivities"
                class="card-box"
              >
                <wm-common-text
                  [data]="{ text: activity?.model?.screenName }">
                </wm-common-text>

                <div class="print-template-row-container">

                  <div class="print-template-left">
                    <wm-print-template-activity-editor
                      *ngIf="expandedIndex === 7 && printTemplateUpdatesForm?.get(activity.id)"
                      [workflowVersionId]="config.sourceWorkflowVersionId"
                      [activity]="activity"
                      [form]="printTemplateUpdatesForm.get(activity.id)"
                    >
                    </wm-print-template-activity-editor>
                  </div>
                </div>
              </div>
            </form>

            <div class="import-workflow-modal-actions" *ngIf="printTemplateFormReady">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{ text: 'Save for Later', type: 'secondary' }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.printTemplateUpdates.completed = true;
                    nextSection()
                  "
                  [disabled]="
                    isSaving ||
                    (!isGlobalAdmin && printTemplateUpdatesForm?.invalid)
                  "
                  [data]="{ text: 'Next', type: 'primary' }">
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- Section 8: Review/Edit Select Contractor Activities / Data Entities -->
          <div *ngSwitchCase="'contractors'">
            <div *ngIf="mustCreateContractorType" class="warning-box">
              <wm-common-text
                [data]="{
                  text: 'In order for this workflow to work properly, there must be at least one Contractor Type. Please Save For Later and configure it first.'
                }">
              </wm-common-text>
            </div>

            <form
              *ngIf="!mustCreateContractorType"
              [formGroup]="contractorUpdatesForm"
            >

              <div
                *ngFor="let activity of config?.selectContractorUpdates?.contractorSelectionActivities"
                class="card-box"
              >
                <div class="section-title">
                  <wm-common-text
                    [data]="{ text: activity?.model?.screenName }">
                  </wm-common-text>
                </div>

                <div class="section-content">
                  <wm-contractor-selection-activity-editor
                    *ngIf="expandedIndex === 8"
                    [activity]="activity"
                    [form]="contractorUpdatesForm?.controls?.[activity.id]"
                    [targetClientId]="targetJurisdictionId"
                  >
                  </wm-contractor-selection-activity-editor>
                </div>
              </div>

              <div
                *ngFor="let scDE of config?.selectContractorUpdates?.selectContractorDataEntities"
                class="card-box"
              >
                <div class="section-title">
                  <wm-common-text
                    [data]="{ text: scDE?.label }">
                  </wm-common-text>
                </div>

                <div class="section-content">
                  <wm-select-contractor-data-entity-editor
                    *ngIf="expandedIndex === 8"
                    [form]="contractorUpdatesForm?.controls?.[scDE.templateCode]"
                    [dataEntity]="scDE"
                    [targetClientId]="targetJurisdictionId"
                  >
                  </wm-select-contractor-data-entity-editor>
                </div>
              </div>

            </form>

            <div class="import-workflow-modal-actions" *ngIf="contractorFormReady">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{ text: 'Save for Later', type: 'secondary' }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.selectContractorUpdates.completed = true;
                    nextSection()
                  "
                  [disabled]="
                    isSaving ||
                    (!isGlobalAdmin && contractorUpdatesForm?.invalid)
                  "
                  [data]="{ text: 'Next', type: 'primary' }">
                </wm-common-button>
              </div>
            </div>

          </div>
          <!-- End Code Added by Sanchit on 04/15/2026 -->

          <!-- Section 9: Select Map Service -->
          <div *ngSwitchCase="'mapService'">
            <form [formGroup]="mapServiceForm" class="form-group">
              <div class="card-box">
                <!-- LABEL -->
                <div class="label-row">
                  <wm-common-text
                    [data]="{ text: 'Select a Map Service:' }">
                  </wm-common-text>
                  <span class="text-danger">*</span>
                </div>

                <!-- DROPDOWN -->
                <div class="dropdown-wrapper">
                  <wm-common-dropdown
                    formControlName="mapServiceTargetId"
                    [data]="{
                      placeholder: '+ Select Map Service',
                      options: mapServiceOptions,
                      style: { width: '100%' }
                    }">
                  </wm-common-dropdown>
                </div>

                <!-- VALIDATION -->
                <wm-control-message
                  [control]="mapServiceForm?.controls?.['mapServiceTargetId']">
                </wm-control-message>
              </div>
            </form>

            <!-- ACTION BUTTONS -->
            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.mapServiceConfiguration.completed = true;
                    nextSection()
                  "
                  [disabled]="isSaving || mapServiceForm?.invalid"
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>
          </div>


          <!-- DEFAULT -->
          <div *ngSwitchDefault>
            <p>Section UI not yet converted</p>

            <div class="actions">
              <wm-common-button
                (click)="saveForLater()"
                [data]="{
                  text: 'Save for Later',
                  type: 'secondary'
                }">
              </wm-common-button>

              <wm-common-button
                (click)="nextSection()"
                [data]="{
                  text: 'Next',
                  type: 'primary'
                }">
              </wm-common-button>
            </div>
          </div>

        </ng-container>

      </div>

    </mat-expansion-panel>

  </mat-accordion>

  <!-- Footer -->
  <div class="footer">
    <wm-common-button
      (click)="saveForLater()"
      [data]="{
        text: 'Save for Later',
        type: 'secondary'
      }">
    </wm-common-button>
    <div class="import-workflow-modal-blue-btn">
      <wm-common-button

        [disabled]="!allSectionsCompleted"
        (click)="openFinishConfirmationModal()"
        [data]="{
          text: 'Finish',
          type: 'primary'
        }">
      </wm-common-button>
    </div>
  </div>

</mat-dialog-content>
<!-- //added by Vipul on 04/19/2026 -->
<div class="modal-width">
  <wm-common-confirmation-modal [data]="finishModal" (onYesClick)="finish()"
    (onNoClick)="finishModal.open=false" (onCloseClick)="finishModal.open=false" [isApplicantMobileview]="true">
    <div class="confirmation-modal-content">
      <wm-common-text
        [data]="{
          text: 'This will finish the workflow configuration and import this workflow into your jurisdiction.'
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text: 'Do you want to continue?'
        }"
      ></wm-common-text>
    </div>
  </wm-common-confirmation-modal>
</div>
<!-- //end by Vipul on 04/19/2026 -->
